module.exports = __webpack_public_path__ + "img/flex.4dc2cc38.svg";